<template>
  <div id="printable" class="register-container">
    <!-- Header -->
    <div class="header">
      <div class="facility-name">
        TUURU COTTOLENGO HEALTH CENTRE - AR2026259
      </div>
      <div class="facility-details">
        <div>Igembe Central</div>
        <div>P.O BOX 77 - Meru | Tel: 254254746758069</div>
        <div>Email: suore.tuuru@cottolengo.org</div>
      </div>
      <div class="register-title">MOH 405 - ANC REGISTER (Antenatal Care)</div>
    </div>

    <!-- Date Range and Generated By Bar -->
    <div class="info-bar">
      <div class="info-left">
        <div class="date-range">
          <div class="info-item">
            <span class="info-label">From:</span>
            <input
              type="date"
              v-model="dateFrom"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <div class="info-item">
            <span class="info-label">To:</span>
            <input
              type="date"
              v-model="dateTo"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <button @click="clearDates" class="btn-clear">Clear</button>
        </div>
        <div class="info-item">
          <span class="info-label">Generated By:</span>
          <span class="info-value">{{ generatedBy }}</span>
        </div>
      </div>
      <button @click="printPage" class="btn-print">Print Register</button>
    </div>

    <!-- Date Range Display for Print -->
    <div class="print-date-range">
      <strong>Report Period:</strong> {{ formattedDateFrom }} to
      {{ formattedDateTo }}
    </div>

    <!-- Summary Statistics -->
    <div class="summary-stats">
      <div class="stat-box">
        <span class="stat-label">Total ANC Visits</span>
        <span class="stat-number">{{ totalAncVisits }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">New Enrollees</span>
        <span class="stat-number">{{ newEnrollees }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">HIV Tested</span>
        <span class="stat-number">{{ hivTested }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">IPTp Doses</span>
        <span class="stat-number">{{ totalIptp }}</span>
      </div>
    </div>

    <!-- Table -->
    <div class="table-wrapper">
      <table class="anc-table">
        <thead>
          <tr>
            <th rowspan="2">#</th>
            <th rowspan="2">ANC No</th>
            <th rowspan="2">Date</th>
            <th rowspan="2">Full Names</th>
            <th rowspan="2">Age</th>
            <th rowspan="2">Gravida</th>
            <th rowspan="2">Para</th>
            <th rowspan="2">EDD</th>
            <th rowspan="2">Gestation (weeks)</th>
            <th rowspan="2">Contact</th>
            <th rowspan="2">SubLocation</th>
            <th colspan="2">HIV Status</th>
            <th rowspan="2">Syphilis Test</th>
            <th rowspan="2">Hb Level</th>
            <th rowspan="2">BP</th>
            <th rowspan="2">Weight (kg)</th>
            <th rowspan="2">IPTp Dose</th>
            <th rowspan="2">TT Dose</th>
            <th rowspan="2">Folic Acid/Iron</th>
            <th rowspan="2">Next Visit</th>
            <th rowspan="2">Remarks</th>
          </tr>
          <tr class="sub-header">
            <th>Tested</th>
            <th>Result</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, index) in filteredRecords" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ record.ancNo }}</td>
            <td>{{ record.date }}</td>
            <td>{{ record.fullNames }}</td>
            <td>{{ record.age }}</td>
            <td>{{ record.gravida }}</td>
            <td>{{ record.para }}</td>
            <td>{{ record.edd }}</td>
            <td>{{ record.gestation }}</td>
            <td>{{ record.contact }}</td>
            <td>{{ record.subLocation }}</td>
            <td class="text-center">
              <span v-if="record.hivTested" class="yes-badge">Yes</span>
              <span v-else class="no-badge">No</span>
            </td>
            <td class="text-center">
              <span v-if="record.hivResult === 'Pos'" class="positive"
                >Positive</span
              >
              <span v-else-if="record.hivResult === 'Neg'" class="negative"
                >Negative</span
              >
              <span v-else class="na-badge">--</span>
            </td>
            <td class="text-center">
              <span v-if="record.syphilisTest === 'Pos'" class="positive"
                >Positive</span
              >
              <span v-else-if="record.syphilisTest === 'Neg'" class="negative"
                >Negative</span
              >
              <span v-else class="na-badge">--</span>
            </td>
            <td>{{ record.hbLevel }}</td>
            <td>{{ record.bp }}</td>
            <td>{{ record.weight }}</td>
            <td>{{ record.iptpDose }}</td>
            <td>{{ record.ttDose }}</td>
            <td class="text-center">
              <span v-if="record.folicAcid" class="yes-badge">Yes</span>
              <span v-else class="no-badge">No</span>
            </td>
            <td>{{ record.nextVisit }}</td>
            <td>{{ record.remarks }}</td>
          </tr>
          <tr v-if="filteredRecords.length === 0">
            <td colspan="22" class="empty-row">
              No ANC records found for the selected date range
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "MOH405ANC",
  data() {
    return {
      dateFrom: "2026-04-01",
      dateTo: "2026-04-30",
      generatedBy: "SR. JANE KAREGI MUNYUGI",
      ancRecords: [
        {
          ancNo: "ANC001",
          date: "2026-04-22",
          fullNames: "Mary Wanjiku",
          age: 28,
          gravida: 2,
          para: 1,
          edd: "2026-08-15",
          gestation: 24,
          contact: "0712345678",
          subLocation: "Kianjai",
          hivTested: true,
          hivResult: "Neg",
          syphilisTest: "Neg",
          hbLevel: "12.5",
          bp: "110/70",
          weight: 65,
          iptpDose: "IPTp 2",
          ttDose: "TT 2",
          folicAcid: true,
          nextVisit: "2026-05-22",
          remarks: "Well, no complaints",
        },
        {
          ancNo: "ANC002",
          date: "2026-04-22",
          fullNames: "Grace Muthoni",
          age: 32,
          gravida: 3,
          para: 2,
          edd: "2026-07-10",
          gestation: 30,
          contact: "0723456789",
          subLocation: "Mutuati",
          hivTested: true,
          hivResult: "Neg",
          syphilisTest: "Neg",
          hbLevel: "11.8",
          bp: "118/75",
          weight: 72,
          iptpDose: "IPTp 3",
          ttDose: "TT 3",
          folicAcid: true,
          nextVisit: "2026-05-22",
          remarks: "Fetal movements good",
        },
        {
          ancNo: "ANC003",
          date: "2026-04-21",
          fullNames: "Jane Karimi",
          age: 24,
          gravida: 1,
          para: 0,
          edd: "2026-09-20",
          gestation: 18,
          contact: "0734567890",
          subLocation: "Kangeta",
          hivTested: true,
          hivResult: "Neg",
          syphilisTest: "Neg",
          hbLevel: "12.0",
          bp: "105/65",
          weight: 58,
          iptpDose: "IPTp 1",
          ttDose: "TT 1",
          folicAcid: true,
          nextVisit: "2026-05-21",
          remarks: "First ANC visit",
        },
        {
          ancNo: "ANC004",
          date: "2026-04-20",
          fullNames: "Sarah Mwikali",
          age: 35,
          gravida: 4,
          para: 3,
          edd: "2026-06-05",
          gestation: 34,
          contact: "0745678901",
          subLocation: "Laare",
          hivTested: true,
          hivResult: "Pos",
          syphilisTest: "Neg",
          hbLevel: "10.5",
          bp: "125/85",
          weight: 68,
          iptpDose: "IPTp 3",
          ttDose: "TT 4",
          folicAcid: true,
          nextVisit: "2026-05-05",
          remarks: "On ARVs, stable",
        },
        {
          ancNo: "ANC005",
          date: "2026-04-19",
          fullNames: "Lucy Mwende",
          age: 29,
          gravida: 2,
          para: 1,
          edd: "2026-10-12",
          gestation: 14,
          contact: "0756789012",
          subLocation: "Kianjai",
          hivTested: false,
          hivResult: "",
          syphilisTest: "",
          hbLevel: "11.2",
          bp: "108/68",
          weight: 62,
          iptpDose: "",
          ttDose: "TT 0",
          folicAcid: true,
          nextVisit: "2026-05-19",
          remarks: "Counseled for HIV test next visit",
        },
        {
          ancNo: "ANC006",
          date: "2026-04-18",
          fullNames: "Esther Kendi",
          age: 26,
          gravida: 1,
          para: 0,
          edd: "2026-11-01",
          gestation: 12,
          contact: "0767890123",
          subLocation: "Mutuati",
          hivTested: true,
          hivResult: "Neg",
          syphilisTest: "Neg",
          hbLevel: "12.8",
          bp: "110/70",
          weight: 55,
          iptpDose: "",
          ttDose: "TT 1",
          folicAcid: true,
          nextVisit: "2026-05-18",
          remarks: "Nausea reported",
        },
        {
          ancNo: "ANC007",
          date: "2026-04-17",
          fullNames: "Ruth Nkirote",
          age: 38,
          gravida: 5,
          para: 4,
          edd: "2026-08-25",
          gestation: 26,
          contact: "0778901234",
          subLocation: "Kangeta",
          hivTested: true,
          hivResult: "Neg",
          syphilisTest: "Neg",
          hbLevel: "10.2",
          bp: "130/90",
          weight: 75,
          iptpDose: "IPTp 2",
          ttDose: "TT 3",
          folicAcid: true,
          nextVisit: "2026-05-17",
          remarks: "Mild hypertension, monitor",
        },
        {
          ancNo: "ANC008",
          date: "2026-04-16",
          fullNames: "Naomi Gacheri",
          age: 31,
          gravida: 3,
          para: 2,
          edd: "2026-09-30",
          gestation: 20,
          contact: "0789012345",
          subLocation: "Laare",
          hivTested: true,
          hivResult: "Neg",
          syphilisTest: "Pos",
          hbLevel: "11.5",
          bp: "115/72",
          weight: 64,
          iptpDose: "IPTp 1",
          ttDose: "TT 2",
          folicAcid: true,
          nextVisit: "2026-05-16",
          remarks: "Syphilis treatment started",
        },
      ],
    };
  },
  computed: {
    formattedDateFrom() {
      return this.dateFrom
        ? new Date(this.dateFrom).toLocaleDateString("en-GB")
        : "Start";
    },
    formattedDateTo() {
      return this.dateTo
        ? new Date(this.dateTo).toLocaleDateString("en-GB")
        : "End";
    },
    filteredRecords() {
      let filtered = this.ancRecords;
      if (this.dateFrom) {
        filtered = filtered.filter((r) => r.date >= this.dateFrom);
      }
      if (this.dateTo) {
        filtered = filtered.filter((r) => r.date <= this.dateTo);
      }
      return filtered;
    },
    totalAncVisits() {
      return this.filteredRecords.length;
    },
    newEnrollees() {
      return this.filteredRecords.filter(
        (r) => r.remarks && r.remarks.toLowerCase().includes("first anc"),
      ).length;
    },
    hivTested() {
      return this.filteredRecords.filter((r) => r.hivTested).length;
    },
    totalIptp() {
      let count = 0;
      this.filteredRecords.forEach((r) => {
        if (r.iptpDose) count++;
      });
      return count;
    },
  },
  methods: {
    clearDates() {
      this.dateFrom = "";
      this.dateTo = "";
    },
    filterRecords() {
      // Computed property handles filtering
    },
    printPage() {
      window.print();
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.register-container {
  background: white;
  min-height: 100vh;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1a56db;
}

.facility-name {
  font-size: 20px;
  font-weight: bold;
  color: #1a56db;
  margin-bottom: 6px;
}

.facility-details {
  font-size: 11px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 10px;
}

.register-title {
  font-size: 14px;
  font-weight: bold;
  background: #f3f4f6;
  display: inline-block;
  padding: 5px 16px;
  border-radius: 20px;
  color: #1f2937;
}

.info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.info-left {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  align-items: center;
}

.date-range {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.info-value {
  font-size: 12px;
  color: #1f2937;
  font-weight: 500;
}

.date-input {
  padding: 5px 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
}

.btn-clear {
  padding: 5px 12px;
  background: #6b7280;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
}

.btn-clear:hover {
  background: #4b5563;
}

.btn-print {
  padding: 8px 20px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
}

.btn-print:hover {
  background: #2563eb;
}

.print-date-range {
  text-align: center;
  padding: 8px;
  margin-bottom: 16px;
  background: #fef3c7;
  border-left: 4px solid #f59e0b;
  font-size: 12px;
  color: #92400e;
  border-radius: 6px;
}

.summary-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.stat-box {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border-radius: 12px;
  padding: 12px 20px;
  text-align: center;
  min-width: 150px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.stat-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #bfdbfe;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.stat-number {
  display: block;
  font-size: 26px;
  font-weight: bold;
  color: white;
}

.table-wrapper {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  max-height: 65vh;
  overflow-y: auto;
}

.anc-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  min-width: 1600px;
}

.anc-table th {
  background: #1f2937;
  color: white;
  padding: 8px 4px;
  font-weight: 600;
  text-align: center;
  border: 1px solid #374151;
  position: sticky;
  top: 0;
  z-index: 10;
}

.anc-table th.sub-header {
  background: #374151;
  font-size: 10px;
}

.anc-table td {
  border: 1px solid #d1d5db;
  padding: 6px 4px;
  text-align: left;
}

.anc-table td.text-center {
  text-align: center;
}

.yes-badge {
  background: #d1fae5;
  color: #065f46;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
}

.no-badge {
  background: #fee2e2;
  color: #991b1b;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
}

.positive {
  background: #fee2e2;
  color: #dc2626;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
}

.negative {
  background: #d1fae5;
  color: #059669;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
}

.na-badge {
  color: #9ca3af;
  font-weight: 500;
}

.empty-row {
  text-align: center;
  padding: 30px;
  color: #6b7280;
}

@media print {
  @page {
    size: landscape;
    margin: 0.3cm;
  }

  .btn-print,
  .btn-clear,
  .date-input {
    display: none;
  }

  .info-bar {
    display: none;
  }

  .print-date-range {
    background: #fef3c7;
    margin: 10px 0;
    padding: 5px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .summary-stats {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .register-container {
    padding: 0.2cm;
  }

  .header {
    margin-bottom: 5px;
  }

  .facility-name {
    font-size: 14px;
  }

  .facility-details {
    font-size: 8px;
  }

  .register-title {
    font-size: 10px;
  }

  .table-wrapper {
    overflow: visible !important;
    max-height: none;
  }

  .anc-table {
    font-size: 8px;
    min-width: 0 !important;
  }

  .anc-table th {
    padding: 3px 2px;
    font-size: 8px;
    background: #e5e7eb !important;
    color: black !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .anc-table td {
    padding: 3px 2px;
    font-size: 7.5px;
  }
}
</style>
